import api from '../../../services/api/';
const URL = '/snapshots';

class SnapshotService {
    getSalesSnapshots(data) {
        const params = [];
        if (data.start_date != undefined && data.start_date != null) {
            params.push("start_date=" + data.start_date);
        }
        if (data.end_date != undefined && data.end_date != null) {
            params.push("end_date=" + data.end_date);
        }
        if (data.year_month != undefined && data.year_month != null) {
            params.push("year_month=" + data.year_month);
        }
        if (data.status != undefined && data.status != null) {
            params.push("status=" + data.status);
        }
        if (data.status_payment != undefined && data.status_payment != null) {
            params.push("status_payment=" + data.status_payment);
        }
        if (data.customer_id != undefined && data.customer_id != null) {
            params.push("customer_id=" + data.customer_id);
        }
        if (data.group_by != undefined && data.group_by != null) {
            params.push("group_by=" + data.group_by);
        }
        return api.get(`${URL}/sales` + (params.length ? '?' + params.join('&') : ''));
    }

    getCustomerSnapshots(data) {
        const params = [];
        if (data.customer_id != undefined && data.customer_id != null) {
            params.push("customer_id=" + data.customer_id);
        }
        if (data.customer_type != undefined && data.customer_type != null) {
            params.push("customer_type=" + data.customer_type);
        }
        if (data.sort_by != undefined && data.sort_by != null) {
            params.push("sort_by=" + data.sort_by);
        }
        if (data.sort_order != undefined && data.sort_order != null) {
            params.push("sort_order=" + data.sort_order);
        }
        if (data.limit != undefined && data.limit != null) {
            params.push("limit=" + data.limit);
        }
        if (data.start_date != undefined && data.start_date != null) {
            params.push("start_date=" + encodeURIComponent(data.start_date));
        }
        if (data.end_date != undefined && data.end_date != null) {
            params.push("end_date=" + encodeURIComponent(data.end_date));
        }
        return api.get(`${URL}/customers` + (params.length ? '?' + params.join('&') : ''));
    }

    getItemSnapshots(data) {
        const params = [];
        if (data.item_id != undefined && data.item_id != null) {
            params.push("item_id=" + data.item_id);
        }
        if (data.item_type != undefined && data.item_type != null) {
            params.push("item_type=" + data.item_type);
        }
        if (data.status != undefined && data.status != null) {
            params.push("status=" + data.status);
        }
        if (data.low_stock != undefined && data.low_stock != null) {
            params.push("low_stock=" + data.low_stock);
        }
        if (data.period != undefined && data.period != null) {
            params.push("period=" + data.period);
        }
        if (data.sort_by != undefined && data.sort_by != null) {
            params.push("sort_by=" + data.sort_by);
        }
        if (data.sort_order != undefined && data.sort_order != null) {
            params.push("sort_order=" + data.sort_order);
        }
        if (data.limit != undefined && data.limit != null) {
            params.push("limit=" + data.limit);
        }
        if (data.start_date != undefined && data.start_date != null) {
            params.push("start_date=" + encodeURIComponent(data.start_date));
        }
        if (data.end_date != undefined && data.end_date != null) {
            params.push("end_date=" + encodeURIComponent(data.end_date));
        }
        return api.get(`${URL}/items` + (params.length ? '?' + params.join('&') : ''));
    }

    getMonthlySummaries(data) {
        const params = [];
        if (data.year != undefined && data.year != null) {
            params.push("year=" + data.year);
        }
        if (data.month != undefined && data.month != null) {
            params.push("month=" + data.month);
        }
        if (data.year_month != undefined && data.year_month != null) {
            params.push("year_month=" + data.year_month);
        }
        if (data.start_date != undefined && data.start_date != null) {
            params.push("start_date=" + data.start_date);
        }
        if (data.end_date != undefined && data.end_date != null) {
            params.push("end_date=" + data.end_date);
        }
        if (data.limit != undefined && data.limit != null) {
            params.push("limit=" + data.limit);
        }
        return api.get(`${URL}/monthly_summaries` + (params.length ? '?' + params.join('&') : ''));
    }

    getDashboardStatistics(params = {}) {
        const query = {};
        if (params.start_date) query.start_date = params.start_date;
        if (params.end_date) query.end_date = params.end_date;
        return api.get(`${URL}/dashboard_statistics`, Object.keys(query).length ? { params: query } : undefined);
    }

    getBillSnapshots(data) {
        const params = [];
        if (data.start_date != undefined && data.start_date != null) {
            params.push("start_date=" + data.start_date);
        }
        if (data.end_date != undefined && data.end_date != null) {
            params.push("end_date=" + data.end_date);
        }
        if (data.year_month != undefined && data.year_month != null) {
            params.push("year_month=" + data.year_month);
        }
        if (data.status != undefined && data.status != null) {
            params.push("status=" + data.status);
        }
        if (data.status_payment != undefined && data.status_payment != null) {
            params.push("status_payment=" + data.status_payment);
        }
        if (data.supplier_id != undefined && data.supplier_id != null) {
            params.push("supplier_id=" + data.supplier_id);
        }
        if (data.group_by != undefined && data.group_by != null) {
            params.push("group_by=" + data.group_by);
        }
        return api.get(`${URL}/bills` + (params.length ? '?' + params.join('&') : ''));
    }

    getSalesActivityChart(data) {
        const params = [];
        if (data.range != undefined && data.range != null) {
            params.push("range=" + data.range);
        }
        return api.get(`${URL}/sales_activity_chart` + (params.length ? '?' + params.join('&') : ''));
    }

    getReceivablesByAge() {
        return api.get(`${URL}/receivables_by_age`);
    }

    getPayablesByAge() {
        return api.get(`${URL}/payables_by_age`);
    }

    getNetIncomeByFiscalYear(data) {
        const params = [];
        if (data.years != undefined && data.years != null && Array.isArray(data.years)) {
            data.years.forEach(year => {
                params.push("years[]=" + year);
            });
        }
        return api.get(`${URL}/net_income_by_fiscal_year` + (params.length ? '?' + params.join('&') : ''));
    }

    getInventoryItemSnapshots(data) {
        const params = [];
        if (data.inventory_item_id != undefined && data.inventory_item_id != null) {
            params.push("inventory_item_id=" + data.inventory_item_id);
        }
        if (data.item_id != undefined && data.item_id != null) {
            params.push("item_id=" + data.item_id);
        }
        if (data.supplier_id != undefined && data.supplier_id != null) {
            params.push("supplier_id=" + data.supplier_id);
        }
        if (data.category_id != undefined && data.category_id != null) {
            params.push("category_id=" + data.category_id);
        }
        if (data.status != undefined && data.status != null) {
            params.push("status=" + data.status);
        }
        if (data.low_stock != undefined && data.low_stock != null) {
            params.push("low_stock=" + data.low_stock);
        }
        if (data.overstocked != undefined && data.overstocked != null) {
            params.push("overstocked=" + data.overstocked);
        }
        if (data.period != undefined && data.period != null) {
            params.push("period=" + data.period);
        }
        if (data.sort_by != undefined && data.sort_by != null) {
            params.push("sort_by=" + data.sort_by);
        }
        if (data.sort_order != undefined && data.sort_order != null) {
            params.push("sort_order=" + data.sort_order);
        }
        if (data.limit != undefined && data.limit != null) {
            params.push("limit=" + data.limit);
        }
        return api.get(`${URL}/inventory_items` + (params.length ? '?' + params.join('&') : ''));
    }
}

export default new SnapshotService();

